import React, { useState, useEffect } from "react";
import { Image } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../Image/Logo3d.png";

function Header() {
  const { t, i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [language, setLanguage] = useState("English");
  const [activeSection, setActiveSection] = useState("home");

  const location = useLocation();
  const navigate = useNavigate();

  const handleToggle = () => {
    setIsOpen((prevState) => !prevState);
  };

  const handleScroll = () => {
    if (window.scrollY > 50) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }

    const sections = document.querySelectorAll("section");
    sections.forEach((section) => {
      const rect = section.getBoundingClientRect();
      if (
        rect.top <= window.innerHeight / 2 &&
        rect.bottom >= window.innerHeight / 2
      ) {
        setActiveSection(section.id);
      }
    });
  };

  const handleLanguageChange = (lang, langName) => {
    i18n.changeLanguage(lang);
    setLanguage(langName);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (location.pathname === "/Blog") {
      window.scrollTo(0, 0);
    }
  }, [location]);

  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
    setActiveSection(sectionId);
  };

  const isBlogPage = location.pathname === "/Blog";
  const handleNavClick = (sectionId) => {
    if (isBlogPage) {
      navigate("/", { replace: true });
      setTimeout(() => {
        scrollToSection(sectionId);
      }, 100);
    } else {
      scrollToSection(sectionId);
    }
  };

  const blogActive = location.pathname === "/Blog" ? "active" : "";

  return (
    <>
      <div className="Header_outer">
        <Navbar
          expand="lg"
          className={`headermain p-0 fixed-top ${
            isScrolled ? "gradient-bg scrolled" : "bgcolor"
          } ${isOpen ? "open-navbar" : ""}`}
        >
          <Container>
            <Navbar.Brand
              as={Link}
              onClick={(e) => {
                e.preventDefault();
                handleNavClick("home");
              }}
              className="d-flex align-items-center headerlogomain"
            >
              <Image src={logo} className="headerLogo" alt="Logo" />
            </Navbar.Brand>
            <Navbar.Toggle
              className="p-0"
              aria-controls="navbarScroll"
              aria-label="Toggle navigation"
              onClick={handleToggle}
            >
              <i
                className={`bi ${isOpen ? "bi-x" : "bi-list"} NavbarToggle`}
              ></i>
            </Navbar.Toggle>

            <Navbar.Collapse
              id="navbarScroll"
              className="justify-content-between"
              in={isOpen}
            >
              <Nav className="my-lg-0">
                <Nav.Link
                  className={`nav-item py-1 ms-1 me-1 ${
                    activeSection === "home" ? "active" : ""
                  }`}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavClick("home");
                  }}
                >
                  {t("home")}
                </Nav.Link>

                <Nav.Link
                  className={`nav-item py-1 ms-1 me-1 ${
                    activeSection === "features" ? "active" : ""
                  }`}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavClick("features");
                  }}
                >
                  {t("features")}
                </Nav.Link>

                <Nav.Link
                  className={`nav-item py-1 ms-1 me-1 ${
                    activeSection === "aboutus" ? "active" : ""
                  }`}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavClick("aboutus");
                  }}
                >
                  {t("about_Us")}
                </Nav.Link>

                <Nav.Link
                  className={`nav-item py-1 ms-1 me-1 ${
                    activeSection === "howItWorks" ? "active" : ""
                  }`}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavClick("howItWorks");
                  }}
                >
                  {t("howItWorks")}
                </Nav.Link>

                <Nav.Link
                  className={`nav-item py-1 ms-1 me-1 ${
                    activeSection === "testimonials" ? "active" : ""
                  }`}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavClick("testimonials");
                  }}
                >
                  {t("testimonials")}
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to="/Blog"
                  className={`nav-item py-1 ms-1 me-1 ${blogActive}`}
                >
                  {t("blogs")}
                </Nav.Link>
              </Nav>

              <div className="d-flex ms-auto header-buttons">
                <div className="language-switcher d-flex align-items-center">
                  <div className="dropdown">
                    <button
                      className="dropdown-toggle rounded-5 px-1 py-1 fw-bold me-3 my-lg-0 my-1"
                      type="button"
                      id="dropdownMenuButton"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {language}
                    </button>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <li>
                        <button
                          className="dropdown-item"
                          onClick={() => handleLanguageChange("en", "English")}
                        >
                          English
                        </button>
                      </li>
                      <li>
                        <button
                          className="dropdown-item"
                          onClick={() => handleLanguageChange("hi", "हिन्दी")}
                        >
                          हिन्दी
                        </button>
                      </li>
                      <li>
                        <button
                          className="dropdown-item"
                          onClick={() => handleLanguageChange("gu", "ગુજરાતી")}
                        >
                          ગુજરાતી
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="social_container d-flex align-items-center mb-lg-0 mb-2 mt-lg-0 mt-1">
                  <a
                    target="_blank"
                    href="https://play.google.com/store/apps/details?id=com.nitya.mala.app"
                    rel="noreferrer"
                    className="btn btn-primary Download-button m-0 text-white d-inline-flex align-items-center justify-content-center text-uppercase"
                  >
                    <i className="bi bi-download me-2"></i> {t("downloadNow")}
                  </a>
                </div>
              </div>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>
    </>
  );
}

export default Header;
